<template>
  <v-col cols="12" sm="6" md="4" class="d-flex">
    <v-card class="elevation-1 flex-grow-1">
      <v-toolbar color="white">
        <v-toolbar-title class="text-md-subtitle-1">
          <span>Performance</span>
          <v-btn
            icon="fa-regular fa-circle-info"
            variant="text"
            aria-label="info"
            color="btncolor"
            @click="showToolTip"
          >
          </v-btn>
        </v-toolbar-title>
      </v-toolbar>
      <v-container pa-0 fluid>
        <v-row v-if="loading" align="center" justify="center">
          <v-col class="pt-0">
            <div class="dashboard-widget-progress-container">
              <v-progress-circular
                :size="75"
                :width="8"
                class="my-auto"
                color="primary"
                indeterminate
              />
            </div>
          </v-col>
        </v-row>

        <v-list v-else two-line dense>
          <v-list-item class="px-0">
            <v-row>
              <v-col cols="2">
                <v-img
                  src="/images/projected_new_closings.png"
                  max-height="30"
                  max-width="30"
                  contain
                />
              </v-col>
              <v-col class="pl-2">
                <v-list-item-title class="font-weight-light performance-text">
                  Projected New Closings *
                </v-list-item-title>
              </v-col>
              <v-col>
                <v-list-item-action class="text-right justify-end">
                  <span class="funnel-count text-h6 performance-text-black">{{
                    projectedNewClosings
                  }}</span>
                </v-list-item-action>
              </v-col>
            </v-row>
          </v-list-item>
          <v-divider inset class="mr-0 mt-2" />
          <v-list-item class="my-4 px-0">
            <v-list-item-title class="text-right">
              <span class="funnel-count text-h6 performance-text-black">
                {{ projectedToClose }}
              </span>
            </v-list-item-title>
            <v-list-item-subtitle class="text-right performance-subtitle">
              projected to close *
            </v-list-item-subtitle>
          </v-list-item>
          <v-list-item class="px-0">
            <v-row>
              <v-col cols="2">
                <v-img
                  src="/images/closed.png"
                  max-height="30"
                  max-width="30"
                  contain
                />
              </v-col>
              <v-col class="pl-2">
                <v-list-item-title class="font-weight-light performance-text"
                  >Total Closed Transactions</v-list-item-title
                >
              </v-col>
              <v-col>
                <v-list-item-action class="text-right justify-end">
                  <span class="funnel-count text-h6 performance-text-black">{{
                    totalClosedTransactions
                  }}</span>
                </v-list-item-action>
              </v-col>
            </v-row>
          </v-list-item>
          <v-divider inset class="mr-0 mt-2" />
          <v-list-item class="my-4 px-0">
            <v-list-item-title class="text-right">
              <span class="funnel-count text-h6 performance-text-black">
                {{ totalClosed }}
              </span></v-list-item-title
            >
            <v-list-item-subtitle class="text-right performance-subtitle">
              total closed
            </v-list-item-subtitle>
          </v-list-item>
          <v-list-item class="px-0">
            <span class="disclaimer px-2">
              * Projected only; not a guarantee.
            </span>
          </v-list-item>
        </v-list>
      </v-container>
    </v-card>
  </v-col>
</template>

<script>
import api from "@/services/api.js";
import { mapGetters } from "vuex";

export default {
  name: "console-overview-performance",
  components: {},
  props: {
    product: {
      type: String,
      default: "COMBINED",
    },
  },
  watch: {
    product() {
      console.log(`performance product changed: ${this.product}`);
      this.parseProductData();
    },
  },
  data() {
    return {
      loading: false,
      statData: {},
      projectedNewClosings: "-",
      projectedToClose: "$0.00",
      totalClosedTransactions: "-",
      totalClosed: "$0.00",
      toolTip: null,
      toolTipDialog: false,
    };
  },
  computed: {
    ...mapGetters("user", ["myBrokerage"]),
    ...mapGetters("auth", ["impBrokerage"]),
  },
  methods: {
    parseProductData() {
      switch (this.product) {
        case "PRIMESTREET":
          this.parsePrimestreetData();
          break;

        case "LEAD_GENIUS":
          this.parseLeadGeniusData();
          break;

        case "COMBINED":
          this.parseCombinedData();
          break;
      }
    },
    parsePrimestreetData() {
      const formatter = new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
        minimumFractionDigits: 0,
      });

      this.projectedNewClosings = "-";
      if (
        this.statData.projectedNewClosings !== undefined &&
        this.statData.projectedNewClosings !== null
      ) {
        this.projectedNewClosings = this.statData.projectedNewClosings;
      }

      this.projectedToClose = "$0";
      if (
        this.statData.projectedToClose !== undefined &&
        this.statData.projectedToClose !== null
      ) {
        this.projectedToClose = formatter.format(
          this.statData.projectedToClose,
        );
      }

      this.totalClosedTransactions = "-";
      if (
        this.statData.totalClosed !== undefined &&
        this.statData.totalClosed !== null
      ) {
        this.totalClosedTransactions = this.statData.totalClosed;
      }

      this.totalClosed = "$0";
      if (
        this.statData.totalClosedValue !== undefined &&
        this.statData.totalClosedValue !== null
      ) {
        this.totalClosed = formatter.format(this.statData.totalClosedValue);
      }
    },
    parseLeadGeniusData() {
      const formatter = new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
        minimumFractionDigits: 0,
      });

      this.projectedNewClosings = "-";
      if (
        this.statData.leadGeniusProjectedNewClosings !== undefined &&
        this.statData.leadGeniusProjectedNewClosings !== null
      ) {
        this.projectedNewClosings =
          this.statData.leadGeniusProjectedNewClosings;
      }

      this.projectedToClose = "$0";
      if (
        this.statData.leadGeniusProjectedToClose !== undefined &&
        this.statData.leadGeniusProjectedToClose !== null
      ) {
        this.projectedToClose = formatter.format(
          this.statData.leadGeniusProjectedToClose,
        );
      }

      this.totalClosedTransactions = "-";
      if (
        this.statData.leadGeniusTotalClosed !== undefined &&
        this.statData.leadGeniusTotalClosed !== null
      ) {
        this.totalClosedTransactions = this.statData.leadGeniusTotalClosed;
      }

      this.totalClosed = "$0";
      if (
        this.statData.leadGeniusTotalClosedValue !== undefined &&
        this.statData.leadGeniusTotalClosedValue !== null
      ) {
        this.totalClosed = formatter.format(
          this.statData.leadGeniusTotalClosedValue,
        );
      }
    },
    parseCombinedData() {
      const formatter = new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
        minimumFractionDigits: 0,
      });

      console.log("Parsing combined data...");
      console.log(this.statData);

      this.projectedNewClosings = "-";
      if (
        this.statData.projectedNewClosings !== undefined &&
        this.statData.projectedNewClosings !== null &&
        this.statData.leadGeniusProjectedNewClosings !== undefined &&
        this.statData.leadGeniusProjectedNewClosings !== null
      ) {
        this.projectedNewClosings =
          this.statData.projectedNewClosings +
          this.statData.leadGeniusProjectedNewClosings;
      } else if (
        this.statData.projectedNewClosings !== undefined &&
        this.statData.projectedNewClosings !== null
      ) {
        this.projectedNewClosings = this.statData.projectedNewClosings;
      } else if (
        this.statData.leadGeniusProjectedNewClosings !== undefined &&
        this.statData.leadGeniusProjectedNewClosings !== null
      ) {
        this.projectedNewClosings =
          this.statData.leadGeniusProjectedNewClosings;
      }

      this.projectedToClose = "$0";
      if (
        this.statData.projectedToClose !== undefined &&
        this.statData.projectedToClose !== null &&
        this.statData.leadGeniusProjectedToClose !== undefined &&
        this.statData.leadGeniusProjectedToClose !== null
      ) {
        this.projectedToClose = formatter.format(
          this.statData.projectedToClose +
            this.statData.leadGeniusProjectedToClose,
        );
      } else if (
        this.statData.projectedToClose !== undefined &&
        this.statData.projectedToClose !== null
      ) {
        this.projectedToClose = formatter.format(
          this.statData.projectedToClose,
        );
      } else if (
        this.statData.leadGeniusProjectedToClose !== undefined &&
        this.statData.leadGeniusProjectedToClose !== null
      ) {
        this.projectedToClose = formatter.format(
          this.statData.leadGeniusProjectedToClose,
        );
      }

      this.totalClosedTransactions = "-";
      if (
        this.statData.totalClosed !== undefined &&
        this.statData.totalClosed !== null &&
        this.statData.leadGeniusTotalClosed !== undefined &&
        this.statData.leadGeniusTotalClosed !== null
      ) {
        this.totalClosedTransactions =
          this.statData.totalClosed + this.statData.leadGeniusTotalClosed;
      } else if (
        this.statData.totalClosed !== undefined &&
        this.statData.totalClosed !== null
      ) {
        this.totalClosedTransactions = this.statData.totalClosed;
      } else if (
        this.statData.leadGeniusTotalClosed !== undefined &&
        this.statData.leadGeniusTotalClosed !== null
      ) {
        this.totalClosedTransactions = this.statData.leadGeniusTotalClosed;
      }

      this.totalClosed = "$0";
      if (
        this.statData.totalClosedValue !== undefined &&
        this.statData.totalClosedValue !== null &&
        this.statData.leadGeniusTotalClosedValue !== undefined &&
        this.statData.leadGeniusTotalClosedValue !== null
      ) {
        this.totalClosed = formatter.format(
          this.statData.totalClosedValue +
            this.statData.leadGeniusTotalClosedValue,
        );
      } else if (
        this.statData.totalClosedValue !== undefined &&
        this.statData.totalClosedValue !== null
      ) {
        this.totalClosed = formatter.format(this.statData.totalClosedValue);
      } else if (
        this.statData.leadGeniusTotalClosedValue !== undefined &&
        this.statData.leadGeniusTotalClosedValue !== null
      ) {
        this.totalClosed = formatter.format(
          this.statData.leadGeniusTotalClosedValue,
        );
      }
    },
    async loadPerformance() {
      this.loading = true;
      let brokerage = this.myBrokerage;
      if (this.impBrokerage !== null) {
        brokerage = this.impBrokerage;
      }

      if (brokerage) {
        try {
          let { data } = await api.brokerage.stats(brokerage);
          this.statData = data;
          this.parseProductData();
        } catch (e) {
          console.log(e);
        } finally {
          this.loading = false;
        }
      } else {
        // TODO: Handle no brokerage set
        this.loading = false;
      }
    },
    showToolTip() {
      this.$emit("toolTip", "OverviewPerformanceToolTip");
    },
  },
  mounted() {
    this.loadPerformance();
  },
};
</script>

<style scoped>
/*See ConsoleOverview for non-scoped classes*/
.disclaimer {
  color: #818181 !important;
  font-weight: 400 !important;
  font-size: 14px !important;
}

.performance-text {
  font-size: 14px !important;
}
.performance-text-black {
  color: black;
}

.performance-subtitle {
  font-size: 12px !important;
  font-weight: 400 !important;
}
</style>
